import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import { MdCheck, MdOutlineCopyAll } from "react-icons/md";
import { CgCheck } from "react-icons/cg";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ProfileModale = ({ account_id, show, handleClose, fetchRecords, userData }) => {
    const {t} = useLanguage()
    const fileInputRef = useRef(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [loadingSave, setLoadingSave] = useState(false)
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false })
    const [checkCopy, setCheckCopy] = useState(false)
    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        email: ""
    });

    useEffect(() => {
        if (userData) {
            setFormData({
                name: userData.name || "",
                surname: userData.surname || "",
                email: userData.email || ""
            });

            setPreviewUrl(userData.profile_url || null);
        }
    }, [userData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    const handleSave = async () => {
        setLoadingSave(true)
        try {
            const data = new FormData();
            data.append("account_id", account_id);
            data.append("name", formData.name);
            data.append("surname", formData.surname);
            data.append("email", formData.email);

            if (selectedImage) {
                data.append("profile_image", selectedImage);
            }

            const response = await fetch(`${GEN_BACKEND_LINK}/update_profile`, {
                method: "POST",
                body: data
            });

            const result = await response.json();

            if (response.ok) {
                setLoadingSave(false)
                fetchRecords();
                handleClose();
            } else {
                setLoadingSave(false)
                console.error(result);
                if (result.error == "email_already_present") {
                    setErrorMessage({ message: `The email ${formData.email} is not available...try another one`, display: true })
                } else {
                    setErrorMessage({ message: "An error occured...retry", display: true })
                }
            }

        } catch (error) {
            setLoadingSave(false)
            setErrorMessage({ message: "Error updating profile...", display: true })
            console.error("Error updating profile:", error);
        }
    };


    const copyItem = (item) => {
        navigator.clipboard.writeText(item)
            .then(() => {
                setCheckCopy(true);
                setTimeout(() => {
                    setCheckCopy(false);
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    const hasProfileImage = previewUrl;

    const closeModal = () => {
        handleClose()
        setErrorMessage({ message: "", display: false })
        setLoadingSave(false)
        setSelectedImage(null)
        setPreviewUrl(userData.profile_url || null)
    }

    return (
        <Modal show={show} onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.profile.title}</p>
            </div>

            <div className="modal_main_cont">
                <div className="profile_image_cont">
                    <div
                        className="profile_image"
                        style={
                            hasProfileImage
                                ? {
                                    backgroundImage: `url(${previewUrl})`,
                                }
                                : {}
                        }
                    >
                        {!hasProfileImage && (
                            <>
                                {formData.name?.charAt(0).toUpperCase()}
                                {formData.surname?.charAt(0).toUpperCase()}
                            </>
                        )}
                    </div>

                    <button
                        className="change_image_btn"
                        onClick={handleImageClick}
                        type="button"
                    >
                        <i className="fa-solid fa-camera"></i>
                    </button>

                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                </div>

                <div className="modal_profile_input_cont">
                    <div className="persona_reg fade-in">
                        <div className="label_input">
                            <label className="input_label">{t.profile.name}</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Name"
                                className="register_form_first person_reg"
                                autoComplete="off"
                            />
                        </div>
                        <div className="label_input">
                            <label className="input_label">{t.profile.surname}</label>
                            <input
                                type="text"
                                name="surname"
                                value={formData.surname}
                                onChange={handleChange}
                                placeholder="Surname"
                                className="register_form_first person_reg"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="label_input">
                        <label className="input_label">{t.profile.email}</label>

                        <input
                            type="text"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Email"
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>
                    <div className="label_input">
                        <label className="input_label">{t.profile.account_id}</label>
                        <p className="register_form_first register_form_first_disabled fade-in" onClick={() => copyItem(account_id)}>{account_id} {checkCopy ? <i className="fade-in"> <MdCheck /></i> : <i className="fade-in"><MdOutlineCopyAll /></i>}</p>
                    </div>
                </div>
                <p className="modal_info_p">{t.profile.info}</p>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>
                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                    >
                        {loadingSave ? (
                            <Spinner loading={true} />
                        ) : (
                            t.save
                        )}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ProfileModale;